import React, { useContext } from 'react';

import Header from '@search/vtbeco-frontend-core/view/common/components/Header';

import { IOnChangeGlobalContext, OnChangeGlobalContext } from '../../../../../client/common/components/GlobalContext';
import useDeveloperPromoRegion from '../../../../../client/common/hooks/useDeveloperPromoRegion';

export default ({
    regionId,
    isFullWidth = false
}: {
    regionId?: number;
    isFullWidth?: boolean;
}) => {
    const onChangeGlobalContext = useContext<IOnChangeGlobalContext>(OnChangeGlobalContext);

    const developerPromoRegionId = useDeveloperPromoRegion(regionId);

    return (
        <Header
            isFullWidth={isFullWidth}
            buildLink={onChangeGlobalContext.linkBuilder.external}
            regionId={regionId}
            developerPromoRegionId={developerPromoRegionId}
        />
    );
};
